import type { ReactNode } from 'react';

interface TagProps {
  children: ReactNode;
  tone?: 'secondary' | 'accent' | 'primary' | 'muted';
  className?: string;
}

const toneMap = {
  secondary: 'bg-secondary-100 text-secondary-900',
  accent: 'bg-accent-100 text-accent-900',
  primary: 'bg-primary-100 text-primary-800',
  muted: 'bg-background-200 text-foreground-700',
};

export default function Tag({ children, tone = 'secondary', className = '' }: TagProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 font-label text-xs whitespace-nowrap ${toneMap[tone]} ${className}`}
    >
      {children}
    </span>
  );
}